/* Surcharges des skins liées à l'affichage RTL */
import {IReg, REG} from "/@lib@/commons/registry.js";

export function ovrReg(reg: IReg<any>) {
	reg.overlaySkin("menu/c-button", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host([aria-haspopup]):after {
		  transform: rotate(90deg);
	  }
	`);

	reg.overlaySkin("bar/c-button", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host([role=menu]:not([disabled])) {
		  background-position: left;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("c-popup-notif", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  c-button {
		  right: unset;
		  left: -.5rem;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("c-bar-actions", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  slot.show {
		  left: unset;
		  right: 0;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("c-bar-shared", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #start.show {
		  left: unset;
		  right: 0;
	  }
	`);

	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("c-arrow-scroll-box", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host(:not([vertical])) > #startBtn {
		  left: unset;
		  right: 0;
	  }

	  :host(:not([vertical])) > #endBtn {
		  right: unset;
		  left: 0;
	  }

	  #startBtn {
		  transform: scaleX(-1);
	  }

	  #endBtn {
		  transform: scaleX(-1);
	  }

	`);


	reg.overlaySkin("dialog/c-button", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `

	  :host([role=menu]) {
		  background-position: left;
	  }

	  :host([role=menu]:hover) {
		  background: var(--pressed-bgcolor) var(--dropdown-url) no-repeat left / 1em;
	  }
	`);

	reg.overlaySkin("c-grid", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  c-button[gridsort] {
		  background-position: left;
	  }
	`);

	reg.overlaySkin("c-grid/tree", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  x-twisty.closed {
		  background-image: url(/@skin@/commons/widgets/grid/closed-rtl.svg);
	  }
	`);


	reg.overlaySkin("c-tabs", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  :host([vertical]) #tabs > .selected {
		  background: linear-gradient(to left, var(--bgcolor), var(--pressed-bgcolor));
	  }
	`);


}